<template>
  <div class="esop-confirmation-form">
    <div class="confirmation-header">
      <div class="check-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h3 class="confirm-title">Confirm Your Order</h3>
      <p class="confirm-subtitle">Review the details below before proceeding</p>
    </div>

    <form class="confirmation-form" @submit.prevent="tradeToken">
      <div class="order-summary">
        <div class="summary-row">
          <span class="summary-label">Order Type</span>
          <span class="summary-value type-badge">{{ tradeType }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">Token</span>
          <span class="summary-value">{{ currentEsop?.name }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">Quantity</span>
          <span class="summary-value highlight">{{ convertToLocale(Number(payload.amount)) }} tokens</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">Unit Price</span>
          <span class="summary-value">{{ formatAmountToDollar(payload.price, 2, "USD") }}</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-row total">
          <span class="summary-label">Total Value</span>
          <span class="summary-value">{{ formatAmountToDollar(payload.price * payload.amount, 2, "USD") }}</span>
        </div>
      </div>

      <PinConfirmation
        class="pin-section"
        :btnTitle="tradeType + ' Now'"
        @confirmed="tradeToken"
      />
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PinConfirmation from "@/components/general/PinConfirmation.vue";
import { convertToLocale, formatAmountToDollar } from "@/utils/helpers";
import { getItem } from "@/utils/storage.js";

export default {
  name: "EsopConfirmationForm",

  components: {
    PinConfirmation,
  },

  data() {
    return {
      payload: {},
      tradeType: "Buy",
    };
  },

  props: {
    currentEsop: { type: Object, default: () => {}, required: true },
  },

  mounted() {
    this.payload = getItem("esopPayload");
  },

  methods: {
    ...mapActions("Esop", ["sellEsop", "buyEsop"]),

    convertToLocale,
    formatAmountToDollar,

    async tradeToken() {
      if (this.tradeType === "Buy") {
        this.payload.id = this.currentEsop._id;
        const response = await this.buyEsop(this.payload);
        if (response) this.$emit("close");
      }
      if (this.tradeType === "Sell") {
        const response = await this.sellEsop(this.payload);
        if (response) this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.esop-confirmation-form {
  padding: 24px;
}

.confirmation-header {
  text-align: center;
  margin-bottom: 32px;
}

.check-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ECFDF5;
  border-radius: 50%;
  color: #10B981;
  margin: 0 auto 16px;
}

.confirm-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 8px 0;
}

.confirm-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: #64748B;
  margin: 0;
}

.order-summary {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;

  &:first-child {
    padding-top: 0;
  }

  &:not(:last-child):not(.total) {
    border-bottom: 1px solid #E2E8F0;
  }

  &.total {
    padding-top: 16px;
  }
}

.summary-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: #64748B;

  .total & {
    font-weight: 500;
    color: #0F172A;
  }
}

.summary-value {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #0F172A;

  &.type-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    background: #EEF2FF;
    color: #4D84FF;
    border-radius: 6px;
    font-size: 13px;
  }

  &.highlight {
    color: #4D84FF;
  }

  .total & {
    font-size: 18px;
    color: #10B981;
  }
}

.summary-divider {
  height: 1px;
  background: #CBD5E1;
  margin: 4px 0;
}

.pin-section {
  margin-top: 8px;
}
</style>
